import {Box, Tabs, Tab} from "@mui/material";
import {useState} from "react";

const tabLinks = [
    { label: "Artists", href: "/community/artists" },
    { label: "Playlists", href: "/community/playlists" },
    { label: "Instagram", href: "/community/instagram-posts" },
    { label: "Members", href: "/community/profiles" }
];

// --- CommunitySubNav component ---
const SubNav = () => {

    const currentPath = window.location.pathname;
    const tabIndex = tabLinks.findIndex(tab => currentPath.startsWith(tab.href.replace(/\/$/, "")));
    const [selectedTab, setSelectedTab] = useState(tabIndex);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        window.location = tabLinks[newValue].href;
    };

    return (
        <Box textAlign="center">
            <Tabs
                size={"small"}
                value={selectedTab}
                onChange={handleTabChange}
                centered
                variant="fullWidth"
                indicatorColor="primary"
                textColor="primary"
            >
                {tabLinks.map((tab) => (
                    <Tab key={tab.href} label={tab.label} />
                ))}
            </Tabs>
        </Box>
    );
};

export default SubNav;